import { getCurrencySymbol } from '@angular/common';

export class BookingExtra {

	CAR = 'CAR';
	HOTEL = 'HOTEL';
	INSURANCE = 'INSURANCE';
	UNKNOWN = 'unknown';

	title: string;
	price: string;
	discountAmount: number;
	logo: string;
	image: string;
	stars: object[];
	link: string;
	provider: string;

	constructor(
		private data: BookingExtraModel,
		private type: string,
		private ancillaryProvider: string
	) {
		this.title = this.getTitle();
		this.logo = this.getProviderLogo();
		this.image = this.getImage();
		this.price = this.priceWithCurrency();
		this.stars = Object.is(this.type, this.HOTEL) ? this.convertRatingsToStars('full', this.data.hotelSpecificDetails.rating) : [];
		this.link = this.getLink();
		this.provider = ancillaryProvider;
	}

	getTitle(): string {
		switch (this.type) {
			case this.CAR:
				return this.data.carSpecificDetails.description;
			case this.HOTEL:
				return this.data.hotelSpecificDetails.description;
			case this.INSURANCE:
				return this.type;
			default:
				return this.UNKNOWN;
		}
	}

	getProviderLogo(): string {
		switch (this.type) {
			case this.CAR:
				return "sprite.svg#partners--cartrawler";
			case this.HOTEL:
				return "sprite.svg#partners--booking";
			case this.INSURANCE:
				return "sprite.svg#partners--chubb";
			default:
				return this.UNKNOWN;
		}
	}

	getImage(): string {
		switch (this.type) {
			case this.CAR:
				return this.data.carSpecificDetails.img;
			case this.HOTEL:
				return this.data.hotelSpecificDetails.img;
			case this.INSURANCE:
				return '/assets/images/ancillaries/offers/insurance.jpg';
			default:
				return this.UNKNOWN;
		}
	}

	priceWithCurrency(): string {
		return this.data.price + ' ' + this.getCurrency();
	}

	convertRatingsToStars(type: string, stars: number): object[] {
		const max_stars = 5;
		if (type === 'full') {
			return new Array(Math.floor(stars));
		} else if (type === 'empty') {
			return new Array(max_stars - Math.floor(stars));
		}
	}

	getLink(): string {
		switch (this.type) {
			case this.CAR:
				return this.data.carSpecificDetails.link;
			case this.HOTEL:
				return this.data.hotelSpecificDetails.link;
			case this.INSURANCE:
				return this.data.insuranceSpecificDetails.link;
			default:
				return null;
		}
	}

	getCurrency() {
		if (!this.data.currency) {
			return '';
		} else {
			return getCurrencySymbol(this.data.currency, 'wide');
		}
	}

}

export interface BookingExtraModel {
	"code": string;
	"price": number;
	"currency": string;
	"points": number;
	"maxQuantity": number;
	"carSpecificDetails"?: CarSpecificDetailsModel;
	"hotelSpecificDetails"?: HotelSpecificDetails;
	"insuranceSpecificDetails"?: InsuranceSpecificDetails;
}

export class CarSpecificDetailsModel {
	"locationDesc": string;
	"description": string;
	"img": string;
	"ac": boolean;
	"carClass": string;
	"doors": number;
	"freeCancel": boolean;
	"fuelPolicy": string;
	"link": string;
	"seats": number;
	"sipp": string;
	"suppImg": string;
	"suppName": string;
	"trans": string;
}

class HotelSpecificDetails {
	"description": string;
	"img": string;
	"link": string;
	"locationDesc": string;
	"rating": number;
}

export interface InsuranceSpecificDetails {
	link: string;
}
